module.exports = __webpack_public_path__ + "static/footer_check_pc-4227aafa8bb75ae7d40d89d20942bdd4.jpg";